import Vue from 'vue'
import Router from 'vue-router'
import DashboardView from '@/modules/Dashboard/DashboardView'
import ReleaseNotesView from '@/components/ReleaseNotesView'
import ContaView from '@/modules/Conta/ContaView'
import LoginView from '@/modules/Login/LoginView'
import PaginaNaoEncontradaView from '@/components/PaginaNaoEncontradaView'
import TipoPerfil from '@/core/types/tipo-perfil'
import Authorization from '@/core/auth/authorization'
import CupomView from '@/modules/Cupom/CupomView'
import UsuarioView from '@/modules/Usuario/UsuarioView'
import CortesiaView from '@/modules/Cortesia/CortesiaView'
import AssinaturasView from '@/modules/Assinaturas/AssinaturasView'
import CriarAssinaturaView from '@/modules/Assinaturas/CriarAssinaturaView'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/usuario',
      meta: { requiresLogin: true }
    },
    {
      path: '/home',
      redirect: '/usuario',
      meta: { requiresLogin: true }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/dashboard/:activeTab?',
      name: 'DashboardView',
      component: DashboardView,
      meta: { requiresLogin: true }
    },
    {
      path: '/conta/:activeTab?',
      name: 'conta',
      component: ContaView,
      meta: { requiresLogin: true, permissions: [ TipoPerfil.MASTER, TipoPerfil.ADMIN, TipoPerfil.ADMIN_RESTRITO, TipoPerfil.ADMIN_JALEKO ] }
    },
    {
      path: '/cupom/:activeTab?',
      name: 'cupom',
      component: CupomView,
      meta: { requiresLogin: true, permissions: [ TipoPerfil.ADMIN_JALEKO ] }
    },
    {
      path: '/cortesia/:activeTab?',
      name: 'cortesia',
      component: CortesiaView,
      meta: { requiresLogin: true, permissions: [ TipoPerfil.ADMIN_JALEKO ] }
    },
    {
      path: '/usuario/:activeTab?',
      name: 'usuario',
      component: UsuarioView,
      meta: { requiresLogin: true, permissions: [ TipoPerfil.ADMIN_JALEKO ] }
    },
    {
      name: 'release-notes',
      path: '/dev/internal/release-notes',
      component: ReleaseNotesView
    },
    {
      name: 'not-found',
      path: 'not-found',
      alias: '*',
      component: PaginaNaoEncontradaView
    },
    {
      path: '/assinaturas/:activeTab?',
      name: 'assinaturas',
      component: AssinaturasView,
      meta: { requiresLogin: true, permissions: [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.MASTER, TipoPerfil.ADMIN ] }
    },
    {
      path: '/assinaturas/criar-assinatura-boleto/:activeTab?',
      name: 'criar-assinatura-boleto',
      component: CriarAssinaturaView,
      props: true,
      meta: { requiresLogin: true, permissions: [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN, TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR, TipoPerfil.ANALISTA, TipoPerfil.MASTER, TipoPerfil.EDITOR ], requiresCompany: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta) {
    const auth = Authorization.authorize(to.meta.requiresLogin, to.meta.permissions)

    if (auth === 'login-required') {
      next({ name: 'login', query: { redir: to.path } })
    } else if (auth === 'unauthorized') {
      next({ path: '/not-found' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
